import React, { ReactElement, useState } from 'react';
import {
  AudioPlayerStateType,
  actions as AudioPlayerActions,
} from '@/components/Player/modules/reducers/audioPlayer';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'elmo-elements';
import config from '@/lib/config/index';

interface SoundVolumeBarProps {
  showMute?: boolean;
  isEnabled?: boolean;
}
const SoundVolumeBar = ({
  showMute,
  isEnabled,
}: SoundVolumeBarProps): ReactElement => {
  const [volume, setVolume] = useState<number>(80);
  const audioPlayer: AudioPlayerStateType = useSelector(
    (state: { audioPlayer: AudioPlayerStateType }) => state.audioPlayer,
  );

  const dispatch = useDispatch();

  function handleOnChange(value: any) {
    // howler volume range from 0 and 1
    dispatch({
      type: AudioPlayerActions.setAudioVolume.type,
      payload: value / 100,
    });

    setVolume(value);
  }

  const toggleMute = () => {
    dispatch({
      type: AudioPlayerActions.setMute.type,
      payload: !audioPlayer.mute,
    });
  };

  if (!audioPlayer.source || !audioPlayer.howler || !showMute) return <div />;

  return (
    <div className="sound-option">
      {audioPlayer.howler && (
        <>
          <Button
            className="mute-button"
            onClick={() => toggleMute()}
            isDisabled={!isEnabled}
            icon={
              audioPlayer.mute ? (
                <img
                  src={`${config.assetPath}volume-mute.svg`}
                  alt="mute icon"
                />
              ) : (
                <img
                  src={`${config.assetPath}volume-unmute.svg`}
                  alt="unmute icon"
                />
              )
            }
          />
          {!audioPlayer.mute && (
            <span className="slider">
              <input
                type="range"
                min={0.0}
                max={100}
                step={0.1}
                value={volume}
                onChange={(e) => {
                  handleOnChange(e.target.value);
                }}
              />
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default SoundVolumeBar;
